module.exports = __webpack_public_path__ + "static/media/RP-A_C_Embroidery_Bicocca_White_IndBlue.4838faca.png";